<template>
    <div>
        <page-header >
            <template #breadcrumbs>
                <router-link to="/analytics">Аналитика</router-link> &raquo; Маршрутизация ЛРАС
            </template>
            <h2>Маршрутизация ЛРАС</h2>
        </page-header>
        <section class="content">
            <report-routing-filter
                    v-bind:filters="filters"
                    v-on:apply="onFiltersApply($event)"
                    v-on:reset="onFiltersReset($event)"
                    v-on:exportReport="exportReport($event)"/>
            <div class="table-inner mb-4" v-if="report">
                <table class="table-custom">
                    <thead>
                    <tr>
                        <th v-for="(hdr,index) in report.header">{{hdr.title}}
                          <i style="cursor: pointer" @click="columnSort(index)"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': sortMode && index === idx, 'text-black': idx === index}"></i>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in report.data">
                        <td v-for="(hdr, index) in report.header">
                            {{item.values[index]}}
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr>
                        <td v-for="val in report.summary[0].values">
                            {{val}}
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import ReportRoutingFilter from "./ReportRoutingFilter";
  import Api from '../api/routing';
  import Constants from "../../../common/constants";
  export default {
    name: "ReportRouting",
    components: {ReportRoutingFilter, PageHeader},
    data() {
      return {
        filters: {
          dateFrom: null,
          dateTo: null,
          districtIds: [],
          opfIds: [],
          orgTypeIds: [],
          serviceTypeIds: [],
          servicesMatch: false,
          eduLevelId: null,
          classKindId: null,
          age: null,
          fields: []
        },
        report: null,
        sortMode: false,
        idx: null,
      }
    },
    methods: {
      loadPage() {
        Api.getReport(this.filters)
          .then((response) => {
            this.report = response.data;
            console.log(this.report)
          })
          .catch(() => {
            this.showError();
          });
      },
      onFiltersApply(filters) {
        this.filters = filters;
        this.loadPage();
      },
      onFiltersReset(filters) {
        this.filters = filters || {};
        this.loadPage();
      },
      exportReport(filters) {
        Api.exportReport(filters);
      },
      showError() {
        Constants.alert.fire('Ошибка', 'При формировании отчета произошла ошибка. Обратитесь в техническую поддержу.', 'error');
      },
      columnSort(index) {
        this.idx = index
        if(this.idxCache !== this.idx) {
          this.sortMode = false
        }
        this.idxCache = index
        let sortM = this.sortMode
        function Sort(x, y){
          if (x.values[index] < y.values[index]) {
            return sortM === true ? -1 : 1;
          }
          if (x.values[index] > y.values[index]) {
            return sortM === true ? 1 : -1;
          }
          return 0;
        }
        this.report.data.sort(Sort);
        this.sortMode = !this.sortMode
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "/src/assets/theme/default/colors.scss";
    .nav-tabs {
        margin-top: 20px;
        justify-content: center;
        border: none;
        .nav-item {
            max-width: 200px;
            width: 100%;
            &:not(:last-child){
                margin-right: 16px;
            }
            .nav-link {
                padding: 7.5px 17.5px;
                text-align: center;
                font-family: "Source Sans Pro", sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 120%;
                color: $gray-dark;
                border: 1px solid $gray-light1;
                box-sizing: border-box;
                border-radius: 6px;

                &.active {
                    color: $blue-light;
                    border: 1px solid $blue-light;
                }
            }
        }
    }

    .btn{
        border-radius: 12px;
        i{
            padding-right: 8px;
        }
    }
    .content{
        padding: 32px ;
        position: relative;
        overflow-y: visible;
        .filter{
            position: absolute;
            width: 350px;
            height: auto;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: transparent;
            opacity: 1;
            transition: opacity .2s;
        }
        .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
        .table-custom .foot {
            font-weight: bold;
        }
        .table-custom tbody tr:last-child td:nth-child(1) {
            border-radius: 0;
        }
        .table-custom tbody tr:last-child td:last-child {
            border-radius: 0;
        }
    }

    
</style>
